export const SET_HRMS14X_INDEX_DISP = 'SET_HRMS14X_INDEX_DISP'
export const GET_HRMS14X_INDEX_DISP = 'GET_HRMS14X_INDEX_DISP'
export const SET_HRMS14X_POPUP_STATUS_EDIT_DISP = 'SET_HRMS14X_POPUP_STATUS_EDIT_DISP'
export const GET_HRMS14X_POPUP_STATUS_EDIT_DISP = 'GET_HRMS14X_POPUP_STATUS_EDIT_DISP'
export const SET_HRMS14X_COLUMNS = 'SET_HRMS14X_COLUMNS'
export const GET_HRMS14X_COLUMNS = 'GET_HRMS14X_COLUMNS'
export const SET_HRMS14X_LABELS = 'SET_HRMS14X_LABELS'
export const GET_HRMS14X_LABELS = 'GET_HRMS14X_LABELS'
export const RECEIVED_HRMS14X_COLUMNS_LABELS = 'RECEIVED_HRMS14X_COLUMNS_LABELS'
export const SET_HRMS14X_INDEX = 'SET_HRMS14X_INDEX'
export const GET_HRMS14X_INDEX = 'GET_HRMS14X_INDEX'
export const RECEIVED_HRMS14X_INDEX = 'RECEIVED_HRMS14X_INDEX'
export const GET_HRMS14X_INDEX_SELECTED = 'GET_HRMS14X_INDEX_SELECTED'
export const SET_HRMS14X_INDEX_SELECTED = 'SET_HRMS14X_INDEX_SELECTED'
export const GET_HRMS14X_POPUP_SELECTED = 'GET_HRMS14X_POPUP_SELECTED'
export const SET_HRMS14X_POPUP_SELECTED = 'SET_HRMS14X_POPUP_SELECTED'

export const GET_HRMS14X_SEARCH_PARAMS_INDEX = 'GET_HRMS14X_SEARCH_PARAMS_INDEX'
export const SET_HRMS14X_SEARCH_PARAMS_INDEX = 'SET_HRMS14X_SEARCH_PARAMS_INDEX'

export const GET_HRMS14X_STATUS_POPUP = 'GET_HRMS14X_STATUS_POPUP'
export const SET_HRMS14X_STATUS_POPUP = 'SET_HRMS14X_STATUS_POPUP'
export const RECEIVED_HRMS14X_STATUS_POPUP = 'RECEIVED_HRMS14X_STATUS_POPUP'

export const GET_HRMS14X_STATUS_EDIT_POPUP = 'GET_HRMS14X_STATUS_EDIT_POPUP'
export const SET_HRMS14X_STATUS_EDIT_POPUP = 'SET_HRMS14X_STATUS_EDIT_POPUP'
export const RECEIVED_HRMS14X_STATUS_EDIT_POPUP = 'RECEIVED_HRMS14X_STATUS_EDIT_POPUP'

export const GET_HRMS14X_ROUTE_NO_POPUP = 'GET_HRMS14X_ROUTE_NO_POPUP'
export const SET_HRMS14X_ROUTE_NO_POPUP = 'SET_HRMS14X_ROUTE_NO_POPUP'
export const RECEIVED_HRMS14X_ROUTE_NO_POPUP = 'RECEIVED_HRMS14X_ROUTE_NO_POPUP'

export const POST_HRMS14X_STATUS_EDIT_SAVE = 'POST_HRMS14X_STATUS_EDIT_SAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hrms14x/mutation-types.js